import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import allAPI from '../../api/api';

export const createVendor = createAsyncThunk('vendorListMapping/createVendor', async (payload) => {
  try {
    const response = await allAPI.vendorListMapping.createVendor(payload);
    if (response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Unexpected status code: ${response.status}`);
    }
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
});

export const getVendorData = createAsyncThunk('vendorListMapping/getVendorData', async (payload) => {
  try {
    const response = await allAPI.vendorListMapping.getVendorData(payload);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected status code: ${response.status}`);
    }
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
});

export const createVendorMap = createAsyncThunk('vendorListMapping/createVendorMap', async (payload) => {
  try {
    const response = await allAPI.vendorListMapping.createVendorMap(payload);
    if (response.status === 201 || response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected status code: ${response.status}`);
    }
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
});


const initialState = {
  vendorData: [],
  status: 'idle',
  error: null,
};

const vendorListMappingSlice = createSlice({
  name: 'vendorListMapping',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVendorData.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getVendorData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.vendorData = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(getVendorData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(createVendor.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createVendor.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // Add the new vendor to vendorData so it appears in the dropdown
        if (action.payload && (action.payload.ID || action.payload.id)) {
          state.vendorData.push(action.payload);
        }
      })
      .addCase(createVendor.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })

      .addCase(createVendorMap.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createVendorMap.fulfilled, (state, action) => {
        state.status = 'succeeded';
        
      })
      .addCase(createVendorMap.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default vendorListMappingSlice.reducer;
